import {Component, HostListener, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EMPTY, Observable} from "rxjs";
import {ComponentCanDeactivate} from "../../pending-changes.guard";
import {apiErrorToMessage, datepickerDefaultToFriday} from "../../common/util";
import {PurchaseOrder, PurchaseOrderStatus, PurchaseOrderUpdateRequest} from "../../api/model/purchase-order";
import {PurchaseOrderService} from "../../api/purchase-order.service";

@Component({
  selector: 'app-purchase-order-edit-dialog',
  templateUrl: './purchase-order-edit-dialog.component.html',
  styleUrls: ['./purchase-order-edit-dialog.component.sass']
})
export class PurchaseOrderEditDialogComponent implements ComponentCanDeactivate {
  editForm = new FormGroup({
    name: new FormControl({value: this.data.purchaseOrder.name, disabled: true}, {validators: [Validators.required]}),
    salesOrderConfirmationNumber: new FormControl({
      value: this.data.purchaseOrder.salesOrderConfirmationNumber,
      disabled: true
    }),
    salesOrderConfirmationDate: new FormControl({
      value: this.data.purchaseOrder.salesOrderConfirmationDate,
      disabled: true
    }),
    estimatedShipByDate: new FormControl({
      value: this.data.purchaseOrder.estimatedShipByDate,
      disabled: true
    }),
  })
  apiError: string | undefined;

  constructor(
    private purchaseOrderService: PurchaseOrderService,
    public dialogRef: MatDialogRef<PurchaseOrderEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PurchaseOrderEditDialogData,
  ) {
    dialogRef.disableClose = true;
    if (this.data.purchaseOrder.status == PurchaseOrderStatus.DRAFT) {
      this.editForm.controls.name.enable()
    }
    if (this.data.purchaseOrder.status == PurchaseOrderStatus.PENDING_INFO || this.data.purchaseOrder.status == PurchaseOrderStatus.ORDERED) {
      this.editForm.controls.salesOrderConfirmationNumber.enable();
      this.editForm.controls.salesOrderConfirmationNumber.addValidators(Validators.required);
      this.editForm.controls.salesOrderConfirmationDate.enable()
      this.editForm.controls.salesOrderConfirmationDate.addValidators(Validators.required);
      this.editForm.controls.estimatedShipByDate.enable()
      this.editForm.controls.estimatedShipByDate.addValidators(Validators.required);
    }
    this.editForm.controls.salesOrderConfirmationNumber.valueChanges.subscribe(_ => {
      if (this.editForm.controls.salesOrderConfirmationDate.value == null) {
        this.editForm.controls.salesOrderConfirmationDate.setValue(new Date(), {emitEvent: false});
      }
    });
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.editForm.dirty;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onPrimaryClick() {
    this.onSubmit()
  }

  datePickerValueChange($event: Date, formControlChange: string) {
    datepickerDefaultToFriday(this.editForm.get(formControlChange), $event);
  }

  onSubmit() {
    this.apiError = undefined;

    const request = {
      name: this.editForm.controls.name.value || undefined,
      salesOrderConfirmationNumber: this.editForm.controls.salesOrderConfirmationNumber.value || undefined,
      salesOrderConfirmationDate: this.editForm.controls.salesOrderConfirmationDate.value?.valueOf() || undefined,
      estimatedShipByDate: this.editForm.controls.estimatedShipByDate.value?.valueOf() || undefined,
    } as PurchaseOrderUpdateRequest;

    if (this.data.alsoSetStatus) {
      request.status = this.data.alsoSetStatus;
    }

    this.purchaseOrderService.update(this.data.purchaseOrder.id, request).subscribe({
      next: (po) => {
        console.log("PurchaseOrderEditDialogComponent updated po", po);
        this.data.purchaseOrder = po;
      },
      error: error => {
        console.log("PurchaseOrderEditDialogComponent failed to edit", error)
        this.apiError = apiErrorToMessage(error);
        return EMPTY
      },
      complete: () => {
        if (!this.apiError) {
          this.dialogRef.close(this.data.purchaseOrder || true)
        }
      }
    });
  }
}

export interface PurchaseOrderEditDialogData {
  purchaseOrder: PurchaseOrder;
  alsoSetStatus?: PurchaseOrderStatus;
}
